import * as Dialog from "@radix-ui/react-dialog";
import { ThemeDialogContent } from "./ThemeDialogContent";
import React from "react";

interface ThemeDialogTriggerProps {
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/** Wrapper component that allows external triggering of ThemeDialog */
export function ThemeDialogTrigger({ children, open, onOpenChange }: ThemeDialogTriggerProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Trigger asChild>
        {children}
      </Dialog.Trigger>
      <ThemeDialogContent />
    </Dialog.Root>
  );
}